import React from 'react'

// Components
import Home from '../components/templates/Home'

const IndexPage = () => <Home />

export default IndexPage
